export default __webpack_public_path__ + "static/media/sideNavDesktop.ff0d76f3.png";